<template>
  <div class="nothing">
    <img src="../../assets/img/pic_nothing.png" alt="暂无">
    <p>暂无内容~</p>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    }
  }
</script>

<style>
.nothing{
  text-align: center;
  margin: 60px auto 0;
}
.nothing img{
  width: 200px;
  height: 200px;
}
.nothing p{
  color: #7c858a;
  font-size: 16px;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Nothing/Nothing.vue